<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>我的服务者</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                    <el-button class="filter-item" type="primary" icon="el-icon-edit" @click="handleCreate">添加</el-button>
                </el-form-item>
            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="tel" label="联系方式"></el-table-column>
                <el-table-column prop="cpUserId" label="企微帐号"></el-table-column>
                <el-table-column prop="cpPicUrl" label="企微二维码">
                    <template slot-scope="scope">
                        <img :src="scope.row.cpPicUrl" style="width:86px"/>
                    </template>
                </el-table-column>
                <el-table-column prop="deleted" label="状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.deleted ? 'success' : 'warning'">{{ scope.row.deleted ? '停用' : '启用'
                        }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>

                <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleUpdate(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="listQuery.pageIndex" :limit.sync="listQuery.pageSize"
                @pagination="querySearch" />
        </el-card>

        <!-- 添加或修改对话框 -->
        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="750px">
            <el-form ref="dataForm" :rules="rules" :model="dataForm" status-icon label-position="left" label-width="120px"
                style="width: 600px; margin-left:50px;">

                <el-form-item label="管家名称" prop="name">
                    <el-input v-model="dataForm.name" placeholder="管家名称" />
                </el-form-item>

                <el-form-item label="管家联系方式" prop="tel">
                    <el-input v-model="dataForm.tel" type="number" placeholder="管家联系方式" />
                </el-form-item>

                <el-form-item label="企微帐号" prop="cpUserId">
                    <el-input v-model="dataForm.cpUserId" placeholder="企微帐号" />
                </el-form-item>

                <el-form-item label="企微二维码" prop="cpPicUrl">
                    <el-upload class="upload-demo" action="123" :limit="1" accept=".png, .jpg, jpeg" :file-list="fileListA"
                        list-type="picture" :on-change="handleOnChangeA" :before-upload="beforeAvatarUploadA"
                        :auto-upload="false">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>

                <el-form-item label="备注" prop="remark">
                    <el-input v-model="dataForm.remark" />
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取消</el-button>
                <el-button v-if="dialogStatus == 'create'" type="primary" @click="createData">确定</el-button>
                <el-button v-else type="primary" @click="updateData">修改</el-button>
            </div>
        </el-dialog>


    </div>
</template>
<script>
import Pagination from "@/components/common/Pagination";
import service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";
import workercrmapi from "@/script/api/workercrmapi";

let vm;
export default {
    components: { Pagination },
    filters: {

    },
    data() {
        return {
            healthCertificateState: {
                0: "未上传",
                1: "已上传",
                2: "健康证即将到期",
                3: "健康证已到期",
            },
            textMap: {
                update: "编辑商家运营",
                create: "创建商家运营",
            },
            fileListA: [],
            dialogFormVisible: false,
            dialogStatus: 'create',
            listData: [],
            total: 0,
            listQuery: {
                pageIndex: 1,
                pageSize: 10
            },
            dataForm: {
                id: undefined,
                name: '',
                tel: '',
                remark: '',
                cpUserId: '',
                cpPicUrl: '',
                deleted: false
            },
            rules: {
                name: [{ required: true, message: "请输入管家名称", trigger: "blur", },],
                tel: [{ required: true, message: "请输入管家电话", trigger: "blur", },],
                cpPicUrl: [{ required: true, message: "请输入管家电话", trigger: "blur", },],
            }
        };
    }, 
    created() {
        this.querySearch();
    },
    methods: {
        handleCreate() {
            this.dataForm = {
                id: undefined,
                name: '',
                tel: '',
                remark: '',
                cpUserId: '',
                cpPicUrl: '',
                deleted: false
            }
            this.dialogFormVisible = true;
            this.dialogStatus = 'create';
            this.fileListA = [];
            this.$nextTick(() => {
                this.$refs["dataForm"].clearValidate();
            });
        },
        createData() {
            console.info(this.dataForm);

            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    workercrmapi
                        .$axiosWorkerManagerCreate(this.dataForm)
                        .then((response) => {
                            this.querySearch();
                            this.dialogFormVisible = false;
                            this.$notify.success({
                                title: "成功",
                                message: "新增成功",
                            });
                        })
                        .catch((response) => {
                            this.$notify.error({
                                title: "失败",
                                message: response.data.errmsg,
                            });
                        });
                }
            });
        },
        handleUpdate(row){
            this.dataForm = {
                id: row.id,
                name: row.name,
                tel: row.tel,
                remark: row.remark,
                cpUserId: row.cpUserId,
                cpPicUrl: row.cpPicUrl,
                deleted: false
            }
            this.dialogFormVisible = true;
            this.dialogStatus = 'update';
            this.fileListA = [];
            this.$nextTick(() => {
                this.$refs["dataForm"].clearValidate();
            });
        },
        updateData() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    workercrmapi
                        .$axiosWorkerManagerUpdate(this.dataForm)
                        .then((response) => {
                            console.info(response)
                            this.querySearch();
                            this.dialogFormVisible = false;
                            this.$notify.success({
                                title: "成功",
                                message: "修改成功",
                            });
                        })
                        .catch((response) => {
                            console.info(response)
                            this.$notify.error({
                                title: "失败",
                                message: response.data.errmsg,
                            });
                        });
                }
            });
        },
        //查询
        querySearch() {
            workercrmapi.$axiosWorkerManagerGetPageList(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                }
            });
        },
        handleOnChangeA(file, fileListA) {
            if (file.raw) {
                let param = new FormData();
                param.append("createAccount", globalData.userInfo.userAccount);
                param.append("file", file.raw);
                service.$ajaxAddFile(param).then((res) => {
                    console.log(res);
                    if (res.data.errno == 0) {
                        this.dataForm.cpPicUrl =
                            res.data.data.fileUrl;
                    }
                });
            }
        },
        beforeAvatarUploadA(file) {
            console.log("jianlai", file);
            const isJPG =
                file.type === "image/jpeg" || "image/jpg" || "image/png";
            const isLt2M = file.size / 1024 / 1024 < 5;

            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG/PNG/JEPG 格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 5MB!");
            }
            return isJPG && isLt2M;
        },

    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}

.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>